module.exports = __webpack_public_path__ + "img/active.508729b9.jpg";